module.exports = __webpack_public_path__ + "media/looknfeel.4873fd58.webm";